import Decimal from 'decimal.js'
import okvedValidator from 'utils/validators/okvedValidator'
import selectValidator from 'utils/validators/selectValidator'
import tinValidator from 'utils/validators/tinValidator'
import noLatinLettersValidator from 'utils/validators/noLatinLetters'
import * as Yup from 'yup'
import i18next from 'i18next'
import phoneValidator from 'utils/validators/phoneValidator'

export default (networkType = '') =>
  Yup.object({
    advertiser_info: Yup.object().shape({
      type: Yup.string()
        .test('isSelected', 'common::validation_messages.required', function test(value) {
          return selectValidator.call(this, value, ['', 'legal', 'individual', 'physical'])
        })
        .required('common::validation_messages.required'),
      tax_number: Yup.string()
        .test(
          'tinValidator',
          'services::forms.shared_fields.advertiser.fields.advertiser_info.tax_number.validation_messages.incorrect_tin_number',
          tinValidator,
        )
        .required('common::validation_messages.required'),
      name: Yup.string()
        .test(
          'noLatinLettersValidator',
          'common::validation_messages.no_latin_letters',
          noLatinLettersValidator,
        )
        .required('common::validation_messages.required'),
      okved_code: Yup.lazy(() =>
        ['yd'].includes(networkType)
          ? Yup.string()
              .nullable()
              .test(
                'okvedCodeValidate',
                'services::forms.shared_fields.advertiser.fields.advertiser_info.okved_code.validation_messages.incorrect_format',
                function test(value) {
                  return okvedValidator.call(this, value)
                },
              )
          : Yup.mixed().notRequired(),
      ),
      phone: ['yandex-business'].includes(networkType)
        ? Yup.mixed().notRequired()
        : Yup.string()
            .test(
              'phoneValidator',
              'common::validation_messages.incorrect_phone_format',
              phoneValidator,
            )
            .required('common::validation_messages.required'),
      kpp: Yup.string().when('advertiser_info.advertiser_info.type', {
        is: (type) => ['yandex-business'].includes(networkType) && !!type && type === 'legal',
        then: () => Yup.string().required('common::validation_messages.required'),
        otherwise: (schema) => schema.notRequired(),
      }),
      counterparty: Yup.object({
        type: Yup.string()
          .test('isSelected', 'common::validation_messages.required', function test(value) {
            return selectValidator.call(this, value, ['', 'legal', 'individual', 'physical'])
          })
          .required('common::validation_messages.required'),
        name: Yup.string()
          .test(
            'noLatinLettersValidator',
            'common::validation_messages.no_latin_letters',
            noLatinLettersValidator,
          )
          .required('common::validation_messages.required'),
        tax_number: Yup.string()
          .test(
            'tinValidator',
            'services::forms.shared_fields.advertiser.fields.advertiser_info.tax_number.validation_messages.incorrect_tin_number',
            tinValidator,
          )
          .required('common::validation_messages.required'),
        phone: ['yandex-business'].includes(networkType)
          ? Yup.mixed().notRequired()
          : Yup.string()
              .nullable()
              .test(
                'phoneValidator',
                'common::validation_messages.incorrect_phone_format',
                phoneValidator,
              ),
        kpp: Yup.string().when('advertiser_info.counterparty.type', {
          is: (type) => ['yandex-business'].includes(networkType) && !!type && type === 'legal',
          then: () => Yup.string().required('common::validation_messages.required'),
          otherwise: (schema) => schema.notRequired(),
        }),
      }),
      contract: Yup.object({
        type: Yup.string()
          .test('isSelected', 'common::validation_messages.required', function test(value) {
            return selectValidator.call(this, value, [
              '',
              'contract',
              'intermediary_contract',
              'additional_agreement',
              'other',
            ])
          })
          .required('common::validation_messages.required'),
        is_charge_paid_by_agent: Yup.boolean().notRequired(),
        type_description: Yup.string()
          .max(
            255,
            i18next.t('common::validation_messages.incorrect_text_length_max', {
              max: 255,
            }),
          )
          .nullable(),
        number: /*Yup.lazy(() =>
          ['yd'].includes(networkType)
            ? Yup.mixed().nullable().notRequired()
            :*/ Yup.string().required('common::validation_messages.required'),
        /*),*/
        date: Yup.string().required('common::validation_messages.required'),
        amount: Yup.string()
          .nullable()
          .test(
            'notBigValue',
            'services::forms.shared_fields.advertiser.fields.advertiser_info.contract.amount.validation_messages.less_than_billion',
            function test(value) {
              const { path, createError } = this

              if (!value || value.length === 0) {
                return true
              }

              const val = new Decimal(value)

              return (
                val.lessThanOrEqualTo('1000000000') ||
                createError({
                  path,
                  message:
                    'services::forms.shared_fields.advertiser.fields.advertiser_info.contract.amount.validation_messages.less_than_billion',
                })
              )
            },
          ),
        subject_type: Yup.string()
          .test('isSelected', 'common::validation_messages.required', function test(value) {
            return selectValidator.call(this, value, [
              '',
              'representation',
              'mediation',
              'distribution',
              'org_distribution',
              'other',
            ])
          })
          .required('common::validation_messages.required'),
        subject_type_description: Yup.string()
          .max(
            255,
            i18next.t('common::validation_messages.incorrect_text_length_max', {
              max: 255,
            }),
          )
          .nullable(),
        action_type: Yup.string()
          .test('isSelected', 'common::validation_messages.required', function test(value) {
            return selectValidator.call(this, value, [
              '',
              'commercial',
              'distribution',
              'conclude',
              'other',
            ])
          })
          .required('common::validation_messages.required'),
        action_type_description: Yup.string()
          .max(
            255,
            i18next.t('common::validation_messages.incorrect_text_length_max', {
              max: 255,
            }),
          )
          .nullable(),
      }),
    }),
  })
